@if(fileDetailsResponse != null) {
<div *ngFor="let key of objectKeys(fileDetailsResponse)"
    class="border rounded-[16px] bg-secondary-100 shadow-sm p-3 mt-2">
    <button class="w-full text-left font-bold" (click)="toggleSection(key)">
        {{ key }}
        <span class="float-right">{{ expanded[key] ? '\<' : '\>' }}</span>
    </button>

    <div *ngIf="expanded[key]" class="mt-2 relative max-h-[95vh] rounded-[16px] overflow-y-auto">
        <button title="{{ 'admin.copy' | transloco }}" (click)="copyToClipboard(fileDetailsResponse![key])"
            class="absolute top-2 right-2 p-2 bg-neutral-200 hover:bg-secondary rounded-full">
            <img src="assets/icons/copy.svg" class="w-[24px] h-[24px]" alt="{{ 'admin.copy' | transloco }}">
        </button>
        <code>
        <pre class="bg-neutral-700 text-sm text-secondary p-4 rounded-[16px] overflow-x-auto whitespace-pre-wrap border border-border">{{ formatJson(fileDetailsResponse![key]) }}</pre>
    </code>
    </div>
</div>}